import { render, staticRenderFns } from "@/modules/AccountCertificate/templates/account-certificate-detail.html?vue&type=template&id=bf485952&scoped=true&"
import script from "@/modules/AccountCertificate/scripts/account-certificate-detail.ts?vue&type=script&lang=js&"
export * from "@/modules/AccountCertificate/scripts/account-certificate-detail.ts?vue&type=script&lang=js&"
import style0 from "@/modules/AccountCertificate/styles/account-certificate-detail.scss?vue&type=style&index=0&id=bf485952&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf485952",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VImg,VTooltip})
